<script setup>
import { ref, onMounted } from 'vue';
import { useTestsStore } from '@stores';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
const testsStore = useTestsStore();

const popovers = ref([]);

const toggle = (event, index) => {
    popovers.value[index]?.toggle(event);
};

const deleteTestHandler = (id) => {
    testsStore.deleteTest(id);
};

const duplicateTestHandler = (test) => {
    testsStore.duplicateTest(test);
};

onMounted(async () => {
    await testsStore.getAllTests();
});
</script>

<template>
    <div class="test-cards">
        <router-link class="test-card" :to="`/tests/${test.id}/main`" v-for="(test, index) in testsStore.allTests" :key="test.id">
            <Button class="test-card-button" variant="text" icon="pi pi-ellipsis-h" @click.prevent="toggle($event, index)" rounded />

            <h2 class="test-card-title">{{ test.name }}</h2>

            <Popover ref="popovers" class="test-popover">
                <ul class="test-popover-items">
                    <li><Button icon="pi pi-copy" variant="text" :label="t('tests.clone')" @click="duplicateTestHandler(test)" /></li>
                    <li><Button icon="pi pi-trash" severity="danger" variant="text" :label="t('tests.delete')" @click="deleteTestHandler(test.id)" /></li>
                </ul>
            </Popover>
        </router-link>
    </div>
</template>

<style scoped>
.test-cards {
    @apply flex flex-wrap gap-4;
}
.test-card {
    @apply cursor-pointer rounded-xl shadow-lg w-[250px] h-[200px] border-t-2 border-[#3e83d0] text-white flex justify-between flex-col p-4;
    background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
}
.test-card-button {
    @apply self-end;
}
.test-card-title {
    @apply text-2xl font-bold mt-4 truncate;
}
:deep.test-card .p-button-icon {
    @apply text-white;
}
:deep.test-card .p-button-text:active,
:deep.test-card .p-button-text:hover {
    @apply bg-inherit;
}
.test-popover-items {
    @apply flex flex-col w-[10rem];
}
:deep.test-popover-items .p-button {
    @apply w-full justify-start;
}
</style>
